import styled from "@emotion/styled";
import { Box } from "@mui/system";

export const ProjectIcon = styled.img`
  width: 24px;
  height: 24px;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.7;
  }
`;

export const TabsBox = styled(Box)`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
